module.exports = __webpack_public_path__ + "static/media/bidding-event.ce15cf80.jpg";